
import RequestAbstract from "../abstract";

export default class FiltersUsers extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/filters-users";
    }
}

